import userService from '../services/user/UserService';
import {captureError} from '../utils/log';

export const TIME_BEFORE_FAILURE = 30000;

const texts = [
  {
    name: 'privacyPolicy',
    timestampName: 'privacyPolicyTimestamp',
    lastMajorVersionUpdateMethod: () => userService.getPrivacyPolicyLastMajorVersionUpdateTimestamp(),
    updateProperty: 'hasPrivacyPolicy'
  },
  {
    name: 'termsAndConditions',
    timestampName: 'termsAndConditionsTimestamp',
    lastMajorVersionUpdateMethod: () => userService.getGeneralTermsLastMajorVersionUpdateTimestamp(),
    updateProperty: 'hasGeneralTerms'
  }
];

const shouldValidateText = async (user, text) => {
  try {
    let generalTimestamp = 1;
    const userTimestamp = user[text.timestampName] || 0;
    if (userTimestamp) {
      generalTimestamp = await text.lastMajorVersionUpdateMethod();
    }

    return generalTimestamp > userTimestamp;
  } catch (error) {
    captureError(`[Authentication error][user: ${user?.id}] lastMajorVersionUpdateMethod() on text ${text?.name}`, error);
    return true;
  }
};

export const getTextsToValidate = (user = {}) => {
  const textsToValidate = [];
  const promises = [];

  for (let i = 0; i < texts.length; i++) {
    promises.push(shouldValidateText(user, texts[i]));
  }

  return Promise.all(promises)
    .then(result => {
      for (let i = 0; i < result.length; i++) {
        if (result[i]) {
          textsToValidate.push(texts[i]);
        }
      }
      return textsToValidate;
    });
};
